import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreateTagPayload extends ISagaCb {
    data: any
    sagaCB: {
        onSuccess: any
    }
}

export interface ICreateTagState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateTagState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createTag = createSlice({
    name: 'tag/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateTagPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createTagActions = createTag.actions
export default createTag.reducer
